<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useSelectedCoilStackStore } from '../stores/selectedCoilStackStore';
import { computed } from 'vue';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { InputGroup, InputNumber, InputGroupAddon } from 'primevue';
import CoilStackPositionSelect from 'shared/coils/components/CoilStackPositionSelect.vue';
import { useSelectedStorageAreaStore } from '../stores/selectedStorageAreaStore';
import { useStorageAreaToCoilStack } from '@/coils/domain/coilStackPositionSelect';

const storageAreaToCoilStack = useStorageAreaToCoilStack();
const selectedCoilStackStore = useSelectedCoilStackStore();
const {
  slots,
  slotsChanged,
  slotWidth,
  slotWidthChanged,
  maxHeight,
  maxHeightChanged,
  maxLevels,
  maxLevelsChanged,
  maxCoilDiameter,
  maxCoilDiameterChanged
} = storeToRefs(selectedCoilStackStore);

const selectedStorageAreaStore = useSelectedStorageAreaStore();
const coilStack = computed(() => {
  const storageArea = selectedStorageAreaStore.currentStorageArea;
  if (!storageArea) return;
  return storageAreaToCoilStack.transform(storageArea);
});
const coilStackVisible = computed(() => {
  if (!coilStack.value) return false;
  return coilStack.value.coils.length > 0;
});

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

</script>

<template>
  <div class="coilstack-grid">
    <div class="field" :class="{ changed: slotsChanged }">
      <label for="coil-stack-slots">{{ translations.coils.slots }}</label>
      <InputNumber pt:pcInputText:root:autocomplete="off" v-model:modelValue="slots" id="coil-stack-slots"></InputNumber>
    </div>
    <div class="field" :class="{ changed: slotWidthChanged }">
      <label for="coil-stack-slotWidth">{{ translations.coils.slotWidth }}</label>
      <InputGroup>
        <InputNumber pt:pcInputText:root:autocomplete="off" v-model:modelValue="slotWidth" id="coil-stack-slotWidth"></InputNumber>
        <InputGroupAddon>mm</InputGroupAddon>
      </InputGroup>
    </div>
    <div class="field" :class="{ changed: maxLevelsChanged }">
      <label for="coil-stack-maxLevels">{{ translations.coils.maxLevels }}</label>
      <InputNumber pt:pcInputText:root:autocomplete="off" v-model:modelValue="maxLevels" id="coil-stack-maxLevels"></InputNumber>
    </div>
    <div class="field" :class="{ changed: maxHeightChanged }">
      <label for="coil-stack-maxHeight">{{ translations.coils.maxHeight }}</label>
      <InputGroup>
        <InputNumber pt:pcInputText:root:autocomplete="off" v-model:modelValue="maxHeight" id="coil-stack-maxHeight"></InputNumber>
        <InputGroupAddon>mm</InputGroupAddon>
      </InputGroup>
    </div>
    <div class="field" :class="{ changed: maxCoilDiameterChanged }">
      <label for="coil-stack-max-coil-diameter">{{ translations.coils.maxCoilDiameter }}</label>
      <InputGroup>
        <InputNumber pt:pcInputText:root:autocomplete="off" v-model:modelValue="maxCoilDiameter" id="coil-stack-max-coil-diameter"></InputNumber>
        <InputGroupAddon>mm</InputGroupAddon>
      </InputGroup>
    </div>
    <div class="coil-stack-view">
      <CoilStackPositionSelect v-if="coilStackVisible" mode="take" v-model:modelValue="coilStack">
      </CoilStackPositionSelect>
    </div>

  </div>
</template>

<style scoped>
.field :deep(.p-inputnumber-input) {
  text-align: right;
}

:deep(.p-inputgroup) {
  height: 33px;
}

.coilstack-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: .5rem;
  column-gap: .5rem;
}

.coil-stack-view {
  grid-column: 1/3;
  overflow-x: auto;
}
</style>
